import { createContext, useContext, useMemo, useState } from "react"
import { getTableDensity, storeTableDensity } from "./TableUtils/TableUtils"

const UiPrefsContext = createContext({
  density: "comfortable",
  setDensity: () => {},
})

export const UiPrefsProvider = ({ children }) => {
  const [density, setDensityState] = useState(getTableDensity)

  const setDensity = (value) => {
    storeTableDensity(value)
    setDensityState(value)
  }

  const value = useMemo(() => ({ density, setDensity }), [density])

  return (
    <UiPrefsContext.Provider value={value}>{children}</UiPrefsContext.Provider>
  )
}

export const useUiPrefs = () => useContext(UiPrefsContext)
